// purpose of this file is to shorten the definition of Columns. e.g., instead of isInteger: true, you would put isInteger.  However, that would require importing each required flag from this file into your vuexModele definition.  There is no way currently 20201020 to import all constants from a JSmodule
export const required = true;
export const isDisabled = true;
export const autofocusWhenCreating = true;
export const inlineEdit = true;
export const isWysiwyg = true;
export const isDate = true;
export const isTime = true;
export const isDateTime = true;
export const isInteger = true;
export const isPercent = true;
export const isNumeric = true;
export const isCurrency = true;
export const isCode = true;
export const isIcon = true;
export const showZeroInPlaceOfNull = true;
export const isButton = true;
export const hideIfAllValuesAreNull = true;
export const editable = true;
export const cellContentIsHidden = true;
export const excludeFromDownloadableColumns = true;
export const isHidden = true;
export const hideWhenDisplaying = true;
export const hideWhenDisplayingInTable = true;
export const hideWhenCreating = true;
export const hideWhenEditing = true;
export const hideWhenCreatingAndEditing = true;
export const hideFromColumnList = true;
export const encrypted = true;
export const disguised = true;
export const isCheckbox = true;
export const isToggle = true;
export const isTable = true;
export const supressAutomaticTooltip = true;
export const isDropdownSelector = true;
export const isDisplayFormatSelector = true;
export const isArray = true;
export const addInfoIconWithContentOfDescriptionField = true;
export const isSectionHeader = true;
export const autogrow = true;
export const hideWhenDisplayingInNonTable = true;
export const limitSavingToOnlyUsingSaveButtonOnTheField = true;
export const isTextarea = true;
export const columnIsNotSpecificToADataField = true;
